import * as React from 'react';
import { Row, Col } from 'reactstrap';
import { IContactInformationForm, IFormValidation, IFormValidationProperties } from '../../model/forms';
import { TextField, USAStateSelect, CountrySelect, PostalCodeField, PhoneNumberField } from '../fields';
import { IFieldEvent } from '../fields/interfaces';

interface IContactInformationProperties extends IFormValidationProperties{
  data: IContactInformationForm;
  validation?: IFormValidation;
  onFieldChanged: (event: IFieldEvent) => void;
}

export default class ContactInformation extends React.PureComponent<IContactInformationProperties> {
  render() {
    return <React.Fragment>
      <Row>
        <Col xs={12} lg={6}>
          <TextField label="First Name" id="ContactInformation_givenName" value={this.props.data.givenName} disabled required />
        </Col>
        <Col xs={12} lg={6}>
          <TextField label="Last Name" id="ContactInformation_familyName" value={this.props.data.familyName} disabled required/>
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={6}>
          <TextField label="Email" id="ContactInformation_email" value={this.props.data.email} disabled required/>
        </Col>
        <Col xs={12} lg={6}>
          <PhoneNumberField 
            label="Contact Number" 
            id="ContactInformation_phone" 
            value={this.props.data.phone} 
            onChange={this.props.onFieldChanged} 
            onValidate={this.props.onValidate} 
            valid={!this.props.validation?.errors?.has("phone")} 
            message={this.props.validation?.errors?.get("phone")} />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <TextField label="Home Address" id="ContactInformation_address" value={this.props.data.address} onChange={this.props.onFieldChanged} />
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={6}>
          <TextField label="City" id="ContactInformation_city" value={this.props.data.city} onChange={this.props.onFieldChanged} />
        </Col>
        <Col xs={12} lg={6}>
          <USAStateSelect label="State" id="ContactInformation_state" value={this.props.data.state} onChange={this.props.onFieldChanged} />
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={6}>
          <PostalCodeField 
            label="Postal Code/Zip Code" 
            id="ContactInformation_postalCode" 
            value={this.props.data.postalCode} 
            onChange={this.props.onFieldChanged} 
            country={this.props.data.country}            
            onValidate={this.props.onValidate} 
            valid={!this.props.validation?.errors?.has("postalCode")} 
            message={this.props.validation?.errors?.get("postalCode")} />
        </Col>
        <Col xs={12} lg={6}>
          <CountrySelect label="Country" id="ContactInformation_country" value={this.props.data.country} onChange={this.props.onFieldChanged} />
        </Col>
      </Row>
    </React.Fragment>;
  }
}